export default __webpack_public_path__ + "static/media/twitter.a04bb01e.svg";